export default {
  SET_USER_TYPE: (state, data) => {
    state.user_type = data;
  },
};
